export enum CollateralEntityDisplayField {
    coverageDeductible = 'coverageDeductible',
    coverageLimit = 'coverageLimit',
    coverageLimitType = 'limitType',
    coverageType = 'coverageType',
    coverageValuation = 'coverageValuation',
    limitRequired = 'limitRequired',
    maximumDeductible = 'maximumDeductible',
}
